import Vue from 'vue'
import Vuex from 'vuex'

import * as Cookies from 'js-cookie'
import VuexPersistence from 'vuex-persist/dist/umd'

import login from './modules/login'
import data from './modules/data'
import generic from './modules/generic'
import hmi from './modules/hmi'
import realtime from './modules/realtime'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexCookie = new VuexPersistence({
  key: "eta-token",
  restoreState(key, storage) {
    return Cookies.getJSON(key);
  },
  saveState(key, state, storage) {
    if ((state.login.token == null) || (state.login.token == {}) || (state.login.token.bearer == null)) {
      Cookies.remove(key);
      return;
    }

    if ((state.login.token != null) && (state.login.token.bearer != null) && (state.login.token.bearer.expires_in != null) && (typeof state.login.token.bearer.expires_in === "number")) {
      let ttl = state.login.token.bearer.expires_in / (24 * 3600);
      Cookies.set(key, state.login.token, {
        expires: ttl,
        secure: !debug,
      });
    }
  },
  modules: ['login'], //only save user module
  filter(mutation) {
    return (mutation.type == 'login/setToken');
  }
});

const vuexGeneric = new VuexPersistence({
  key: "eta-gen",
  storage: window.localStorage,
  reducer: state => ({
    data: state.generic
  }), //only save navigation module
});

const vuexRealtime = new VuexPersistence({
  key: "eta-realtime",
  storage: window.sessionStorage,
  reducer: state => ({
    data: state.realtime
  }), //only save navigation module
});

const vuexHMI = new VuexPersistence({
  key: "eta-hmi",
  storage: window.localStorage,
  reducer: state => ({
    data: state.hmi
  }), //only save navigation module
});

export default new Vuex.Store({
  modules: {
    login,
    generic,
    realtime,
    hmi,
    data,
  },
  plugins: [vuexCookie.plugin, vuexGeneric.plugin, vuexRealtime.plugin, vuexHMI.plugin]
})
